// import { AgCharts } from "ag-charts-react";

// const DonutGST = ({ data }) => {
//   const total = data.reduce((sum, d) => sum + (Number(d.value) || 0), 0);
//   console.log("Donut data:", data, "Total:", total);

//   const categoryColorMap = {
//     VALID: "#4CAF5099",   
//     EXCEPTION: "#F0808099", 
//     INVALID: "#E5393599",   
//     LOCKED: "#ADD8E699",    
//     ACTIVE: "#4CAF5099", 
//     UNKNOWN:"#FFB30099",
//     SUCCESS:"#4CAF5099",
//     FAILED_LOGIN:"#E5393599",
//     NULL:"#FFB30099",
//     "NOT AVAILABLE": "#FFB30099",
//     "WRONG CREDENTIAL": "#E5393599",
//     "ERROR VERIFYING": "#4682B499"
//   };

//   const formatNumber = (value) => {
//     const truncate = (num, digits) => {
//       const multiplier = Math.pow(10, digits);
//       return Math.floor(num * multiplier) / multiplier;
//     };

//     if (value >= 1e7) return truncate(value / 1e7, 2).toFixed(2) + 'Cr';
//     if (value >= 1e5) return truncate(value / 1e5, 2).toFixed(2) + 'L';
//     return value.toString();
//   };

//   const fills = data.map(d => categoryColorMap[d.category?.toUpperCase()] || "#CCCCCC99");
//   return (
//     <div style={{ height: '190px' }}>
//       <AgCharts
//         options={{
//           width: 190,
//           height: 190,
//           data,
//           series: [
//             {
//               type: "donut",
//               angleKey: "value",
//               calloutLabelKey: "category",
//               calloutLabel: { enabled: false },
//               innerRadiusRatio: 0.6,
//               // innerLabels: [
//               //   {
//               //     text: "Credential",
//               //     fontSize: 12,
//               //     color: "#A3A6B7",
//               //     textAlign: "center",
//               //   },
//               //   {
//               //     text: total.toString(),
//               //     fontWeight: "bold",
//               //     fontSize: 32,
//               //   },
//               // ],
//               innerLabels: [
//                 {
//                   // text: total.toString(),
//                   text: formatNumber(total),
//                   fontWeight: 500,
//                   fontSize: 24,
//                   color: "#000",
//                   textAlign: "center",
//                 },
//                 {
//                   text: "Credentials",
//                   fontSize: 12,
//                   color: "#888",
//                   textAlign: "center",
//                 },
//               ],

//               label: { enabled: false },
//               //fills: ["#4CAF5099", "#E5393599", "#FFB30099"],
//               //strokes: ["white", "white", "white"],
//               fills,
//               strokes: Array(data.length).fill("white"),
//               tooltip: {
//                 renderer: ({ datum }) => {
//                   return {
//                     title: datum.category,
//                     content: `Count: ${datum.value}`,
//                   };
//                 },
//               },
//             },
//           ],
//           legend: {
//             enabled: false,
//             position: "bottom",
//           },
//         }}
//       />
//     </div>
//   );
// };


// export default DonutGST;


import { AgCharts } from "ag-charts-react";
import ErrorIcon from '@mui/icons-material/Error'; // or use any custom icon

const DonutGST = ({ data }) => {
  const total = data.reduce((sum, d) => sum + (Number(d.value) || 0), 0);
  console.log("Donut data:", data, "Total:", total);

  const categoryColorMap = {
    VALID: "#4CAF5099",
    EXCEPTION: "#F0808099",
    INVALID: "#E5393599",
    LOCKED: "#ADD8E699",
    // LOCKED: "pink",
    ACTIVE: "#4CAF5099",
    UNKNOWN: "#FFB30099",
    SUCCESS: "#4CAF5099",
    FAILED_LOGIN: "#E5393599",
    NULL: "#FFB30099",
    "NOT AVAILABLE": "#FFB30099",
    "WRONG CREDENTIAL": "#E5393599",
    "ERROR VERIFYING": "#4682B499",
  };

  const formatNumber = (value) => {
    const truncate = (num, digits) => {
      const multiplier = Math.pow(10, digits);
      return Math.floor(num * multiplier) / multiplier;
    };

    if (value >= 1e7) return truncate(value / 1e7, 2).toFixed(2) + 'Cr';
    if (value >= 1e5) return truncate(value / 1e5, 2).toFixed(2) + 'L';
    return value.toString();
  };

  const fills = data.map(d => categoryColorMap[d.category?.toUpperCase()] || "#CCCCCC99");

  return (
    <div style={{ height: '190px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
      {data && data.length > 0 ? (
        <AgCharts
          options={{
            width: 190,
            height: 190,
            data,
            series: [
              {
                type: "donut",
                angleKey: "value",
                calloutLabelKey: "category",
                calloutLabel: { enabled: false },
                innerRadiusRatio: 0.6,
                innerLabels: [
                  {
                    text: formatNumber(total),
                    fontWeight: 500,
                    fontSize: 24,
                    color: "#000",
                    textAlign: "center",
                  },
                  {
                    text: "Credentials",
                    fontSize: 12,
                    color: "#888",
                    textAlign: "center",
                  },
                ],
                label: { enabled: false },
                fills,
                strokes: Array(data.length).fill("white"),
                tooltip: {
                  renderer: ({ datum }) => {
                    return {
                      title: datum.category,
                      content: `Count: ${datum.value}`,
                    };
                  },
                },
              },
            ],
            legend: {
              enabled: false,
              position: "bottom",
            },
          }}
        />
      ) : (
        // 👇 Replace this with any icon or text you'd like
        <div style={{
          display:'flex',
          flexDirection:'column',
          alignItems:'center'
        }}>
          <svg xmlns="http://www.w3.org/2000/svg" width="41" height="40" viewBox="0 0 61 60" fill="none">
          <path d="M30.5 42.5C31.2083 42.5 31.8025 42.26 32.2825 41.78C32.7625 41.3 33.0017 40.7067 33 40C32.9983 39.2933 32.7583 38.7 32.28 38.22C31.8017 37.74 31.2083 37.5 30.5 37.5C29.7917 37.5 29.1983 37.74 28.72 38.22C28.2417 38.7 28.0017 39.2933 28 40C27.9983 40.7067 28.2383 41.3008 28.72 41.7825C29.2017 42.2642 29.795 42.5033 30.5 42.5ZM30.5 32.5C31.2083 32.5 31.8025 32.26 32.2825 31.78C32.7625 31.3 33.0017 30.7067 33 30V20C33 19.2917 32.76 18.6983 32.28 18.22C31.8 17.7417 31.2067 17.5017 30.5 17.5C29.7933 17.4983 29.2 17.7383 28.72 18.22C28.24 18.7017 28 19.295 28 20V30C28 30.7083 28.24 31.3025 28.72 31.7825C29.2 32.2625 29.7933 32.5017 30.5 32.5ZM30.5 55C27.0417 55 23.7917 54.3433 20.75 53.03C17.7083 51.7167 15.0625 49.9358 12.8125 47.6875C10.5625 45.4392 8.78167 42.7933 7.47 39.75C6.15834 36.7067 5.50167 33.4567 5.5 30C5.49834 26.5433 6.155 23.2933 7.47 20.25C8.785 17.2067 10.5658 14.5608 12.8125 12.3125C15.0592 10.0642 17.705 8.28333 20.75 6.97C23.795 5.65667 27.045 5 30.5 5C33.955 5 37.205 5.65667 40.25 6.97C43.295 8.28333 45.9408 10.0642 48.1875 12.3125C50.4342 14.5608 52.2158 17.2067 53.5325 20.25C54.8492 23.2933 55.505 26.5433 55.5 30C55.495 33.4567 54.8383 36.7067 53.53 39.75C52.2217 42.7933 50.4408 45.4392 48.1875 47.6875C45.9342 49.9358 43.2883 51.7175 40.25 53.0325C37.2117 54.3475 33.9617 55.0033 30.5 55Z" fill="#CCCCCC" />
        </svg>
        <span style={{
          color: '#AAA',
          fontSize: '14px',
          fontWeight: 400,
          marginTop:'4px'
        }}>No data Available</span>
        </div>
        
      )}
    </div>
  );
};

export default DonutGST;
